import { fetch } from '@atlassian/eoc-fetch';
import type {
	CloneScheduleResponse,
	CreateScheduleResponse,
} from '@atlassian/eoc-schedule-common/types/schedule';

import { urls } from '../../../common/constants/urls';

import type {
	CloneScheduleParameters,
	CreateScheduleParameters,
	ScheduleRightsResponse,
} from './types';

const getScheduleRights = (teamId: string): Promise<ScheduleRightsResponse> => {
	return fetch<ScheduleRightsResponse>(urls.schedules.teams.teamId.rights.url({ teamId }));
};

const createSchedule = ({
	description,
	name,
	teamId,
	timezone,
}: CreateScheduleParameters): Promise<CreateScheduleResponse> => {
	return fetch<CreateScheduleResponse>(urls.schedules.url(), {
		method: 'POST',
		body: {
			description,
			name,
			teamId,
			timezone,
			// Created schedules are enabled by default
			enabled: true,
		},
	});
};

const cloneSchedule = ({
	description,
	name,
	enabled,
	timezone,
	teamId,
	scheduleId,
}: CloneScheduleParameters): Promise<CloneScheduleResponse> => {
	return fetch<CloneScheduleResponse>(urls.schedules.scheduleId.clone.url({ scheduleId }), {
		method: 'POST',
		body: {
			description,
			name,
			enabled,
			timezone,
			teamId,
		},
	});
};

export const endpoints: {
	cloneSchedule: ({
		description,
		name,
		enabled,
		timezone,
		teamId,
		scheduleId,
	}: CloneScheduleParameters) => Promise<CloneScheduleResponse>;
	createSchedule: ({
		description,
		name,
		teamId,
		timezone,
	}: CreateScheduleParameters) => Promise<CreateScheduleResponse>;
	getScheduleRights: (teamId: string) => Promise<ScheduleRightsResponse>;
} = { createSchedule, getScheduleRights, cloneSchedule };
